// fetch with the headers jQuery's $.ajax used to send. Laravel tells AJAX apart by X-Requested-With:
// $request->ajax() gates the create forms, the summoner check and the card stats, and expectsJson() turns
// validation errors into a 422 JSON. A non-2xx response throws an HttpError with the JSON body, if there is one
export const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content;

export class HttpError extends Error {
    constructor(status, data) {
        super(`HTTP ${status}`);
        this.status = status;
        this.data = data;
    }
}

export async function request(url, {method = 'GET', body} = {}) {
    const response = await fetch(url, {
        method,
        body,
        headers: {'X-Requested-With': 'XMLHttpRequest', 'X-CSRF-TOKEN': csrfToken},
    });

    if (!response.ok) {
        const isJson = response.headers.get('Content-Type')?.includes('json');
        throw new HttpError(response.status, isJson ? await response.json().catch(() => null) : null);
    }

    return response;
}
